import React from "react"

export default function LevelLeft(props) {
  return <div className={`level-left ${props.className}`}>{props.children}</div>
}
